<!-- <p>hierarchy-dashboard works!</p> -->
<div class="content-center2" *ngIf="thisUser && hierarchicalData && selectedLocation !='' "
	style="display: flex; flex-wrap: nowrap;flex-direction: column; height: 100%;">

	<nav class="navbar-breadcrumb navbar-expand-lg alignRow" id="breadcrumbs">
		<ejs-breadcrumb #pageBreadcrumbs [enableNavigation]="false" [items]="breadcrumbItems"
			*ngIf="breadcrumbItems.length > 0" (itemClick)="onItemClick($event)">
		</ejs-breadcrumb>

		<!-- <ol class="breadcrumb alignRow">
			<li class="breadcrumb-item" *ngFor="let parent of locationParents" (click)="locationSelect(parent.Uid)"
				[matTooltip]="parent.Description">
				<span style="display: flex;">
					<mat-icon style="color: grey !important" />{{parent.Name}}</span>
			</li>
			<li class="breadcrumb-item alignRow"
				*ngIf="(locationParents && locationParents.length > 0) && locationParents[0].Uid != hierarchicalLocation?.Uid">
				<mat-icon style="color: grey !important" />{{hierarchicalLocation?.Name}}
			</li>
		</ol> -->
		<span class="me-auto"></span>
		<button class="search-button alignRow" (click)="searchForAsset()">
			<span>Search for Asset</span>
			<mat-icon>search</mat-icon>
		</button>
	</nav>
	<div class="topcontainer">
		<div class="leftcont" *ngIf="hierarchicalLocation">
			<ng-container *ngTemplateOutlet="FuntionalLocations; context: { $implicit: hierarchicalLocation }">
			</ng-container>
		</div>
		<div class="rightcont " *ngIf="locationAssets.length > 0">
			<ng-container *ngTemplateOutlet="ngAssetTemplate"></ng-container>
		</div>
	</div>

	<ng-container *ngIf="locationChildren.length > 0 then ngSubLocationTemplate;"></ng-container>

	<router-outlet></router-outlet>

</div>

<!-- Functional Locations View -->
<ng-template #FuntionalLocations let-location>
	<span class="levelBackButton alignRow app-icon--back" (click)="locationSelect(location.ParentUid)"
		*ngIf="location.ParentUid != location.OrganisationUID">
		<mat-icon matTooltip="Back To Parent Location"/>
	</span>
	<span class="newEntryButton app-icon app-icon--add">
		<mat-icon *ngIf="thisUser.AdminSite && !hideButtons" [matMenuTriggerFor]="newEntry"
			matTooltip="Add New Entry" />
	</span>
	<div *ngIf="location.Level <= 1" class="hierarchy-imageContainer">
		<img src="{{imagePathOrganisations()}}{{location.Id}}?{{location.Modified}}"
			title="{{location.Name}} - {{location.LocationType}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'" />
	</div>
	<app-asset-tiles-group *ngIf="location.Level > 1" [inputSubLocation]="location" [AdminSite]="thisUser.AdminSite"
		(hideButtons)="toggleHideButtons($event)"></app-asset-tiles-group>
</ng-template>

<mat-menu #newEntry="matMenu" [overlapTrigger]="false" yPosition="below">
	<button class="app-icon app-icon--add-asset" mat-menu-item (click)="addAsset(hierarchicalLocation!)">
		<mat-icon /><span>New Asset</span>
	</button>
	<button class="app-icon app-icon--add-location" mat-menu-item (click)="addLocation(hierarchicalLocation!)">
		<mat-icon /><span>New Location</span>
	</button>
</mat-menu>

<ng-template #ngSubLocationTemplate>
	<!-- <ejs-toolbar class="assettoolbar" id="subLocationToolbar"
		*ngIf="locationChildren.length > 0 && hierarchicalLocation">
		<e-items>
			<e-item align="Right">
				<ng-template #template>
					<span style="margin-right: 1em;">{{locationChildren.length}}</span>
					<span>&nbsp;Function Locations in&nbsp;{{hierarchicalLocation.Name}}</span>
				</ng-template>
			</e-item>
			<e-item align="Right">
				<ng-template #template>
					<span class="app-icon app-icon--add" style="margin: auto;">
						<mat-icon *ngIf="thisUser.AdminSite" (click)="addLocation(hierarchicalLocation!)"
							matTooltip="Add New Function Location"></mat-icon>
					</span>
				</ng-template>
			</e-item>
		</e-items>
	</ejs-toolbar> -->
	<span class="flex-wrap-locations" id="ngSubLocationTemplate">
		<ng-container id="ngLocationDiv" class="" *ngFor="let subLocation of locationChildren"
			matTooltip="{{subLocation.Name}}">
			<app-hierarchy-sub-location (selected)="locationSelect($event.Uid)" [child]=subLocation
				[accountID]="accountGUID" [OrganisationID]="OrganisationUID"
				[AdminSite]="thisUser.AdminSite"></app-hierarchy-sub-location>
		</ng-container>
	</span>
</ng-template>

<ng-template #ngAssetTemplate>
	<ejs-toolbar class="assettoolbar" id="assetToolbar" *ngIf="locationChildren && hierarchicalLocation">
		<e-items>
			<e-item>
				<ng-template #template>
					<span>{{locationAssets.length}}&nbsp;Assets in&nbsp;{{hierarchicalLocation.Name}}</span>
				</ng-template>
			</e-item>
			<e-item align="Right">
				<ng-template #template>
					<span class="app-icon app-icon--add"><mat-icon *ngIf="thisUser.AdminSite"
							(click)="addAsset(hierarchicalLocation!)" matTooltip="Add New Asset" /></span>
				</ng-template>
			</e-item>
		</e-items>
	</ejs-toolbar>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='locationAssets' [cssClass]='cssClass'>
		<ng-template #template let-dataSource>
			<div class="ejs-listview-item listview-asset" (click)="assetSelect(dataSource)"
				[ngClass]="dataSource.Actioned ? 'actioned' : dataSource.Watch ? 'watchActive' : ''" [ngStyle]="{
					'border': dataSource.AssetID == selectedAsset?.AssetID ? '2px solid var(--prism-blue)' : '',
					'border-radius': dataSource.AssetID == selectedAsset?.AssetID ? 'var(--default-border-radius)' : ''}">
				<img class="assetImage" src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource.Modified}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					(click)='viewImage(imagePathAssets() + dataSource.AssetID + "?" + dataSource.Modified)'
					[attr.x-contenttype]="'image/png'" />
				<div class="assetDetail">
					<div id="id-name" class="assetName">{{ dataSource.Name}}
						<mat-icon *ngIf=" dataSource.Watch == true"
							style="margin-left: var(--default-margin);">visibility
						</mat-icon>
					</div>
					<div id="id-description" class="assetInfo">{{dataSource.Description }}</div>

					<div *ngIf="checkFeature(AccountFeatures.SAP)" id="id-info1" class="assetInfo">
						@if (dataSource.FunctionalLocation) {
						<span><b>FL Code</b> - {{dataSource.FunctionalLocation}}&nbsp;</span>
						} @else if (dataSource.ParentFunctionalLocation) {
						<span><b>FL Code</b> - {{dataSource.ParentFunctionalLocation}}&nbsp;</span>
						}

						@if (dataSource.EquipmentCode) {
						<span><b>EQ Code</b> - {{dataSource.EquipmentCode}}&nbsp;</span>
						}
					</div>
				</div>
				<div class="me-auto"></div>
				<div style="padding: 1em;" class="alignRow">
					<span *ngIf="checkIfAssetFlagged(dataSource)" class="app-icon app-icon--flagged"
						matTooltip="Remove from Flagged Assets" matTooltipPosition="above">
						<mat-icon (click)="removeFlaggedAsset(dataSource)" />
					</span>
					<span *ngIf="!checkIfAssetFlagged(dataSource)" class="app-icon app-icon--add-flagged"
						matTooltip="Add to Flagged Assets" matTooltipPosition="above">
						<mat-icon (click)="addFlagged(dataSource)" />
					</span>
				</div>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>